export default __webpack_public_path__ + "static/media/Interactive Map.bce06de8.svg";